import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
//import { EnrollmentDataService } from '../../gateways/enrollment-data-service'
import { PortalGlobals } from '../../../portalglobals'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { AlphaNumericFieldValidator } from '../../../validations/alpha-numeric-field-validator'

@Component({
    selector: 'stcob-fields',
    templateUrl: './STCOB-Fields.component.html'
})

export class STCOBComponent implements OnInit {
    @Input() disabled: boolean = false
    notBlankValidator = new NotBlankGenericFieldValidator()
    numericValidator: NumericTextFieldValidator = new NumericTextFieldValidator()
    alphanumericValidator: AlphaNumericFieldValidator = new AlphaNumericFieldValidator()
    //isValidAgent: boolean
    public RelCode: ValidatedSelectOptionModel[] = []
    public PersonCode: ValidatedSelectOptionModel[] = []
    @Input() enrollment: EnrollmentViewModel
    @Input() isSingleGroup: boolean = false

    constructor(private _enrollementGateway: EnrollmentGateway, public _global: PortalGlobals
    ) {
    }

    ngOnInit(): void {
        this.RelCode.push({ text: 'Not Specified', value: '00' }, { text: 'Employee', value: '01' }, { text: 'Spouse', value: '02' }, { text: 'Child', value: '03' }, { text: 'Other', value: '04' })
        this.PersonCode.push({ text: 'Card Holder', value: '01' }, { text: 'Spouse', value: '02' }, { text: 'First Dependent', value: '03' }, { text: 'Second Dependent', value: '04' })
    }

    relationChange(event: any) {
        this.enrollment.RELCD = event
        this.enrollment.RELTEXT = this.RelCode.filter(x => x.value === event)[0].text
    }

    personChange(event: any) {
        this.enrollment.PERSONCD = event
        this.enrollment.PERSONTEXT = this.PersonCode.filter(x => x.value === event)[0].text
    }

}